/**
 * Created by Desarrollo KJ on 20/3/2017.
 */
import {Component, OnInit} from '@angular/core';
import {ApiService} from './../../../services/api.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'my-shopping',
  template: require('./myShopping.html'),
  styles: [require('./myShopping.scss')]
})
export class MyShoppingComponent implements OnInit {

  public facturaDefault: any = {
    idFactura:null,
    formaPago:'',
    facturasDetalles:[],
    creacion:''
  };

  public pais:any = JSON.parse(localStorage.getItem('pais'));

  constructor(private _api: ApiService, private _activatedRoute: ActivatedRoute, private _router: Router) {
    this._activatedRoute.params.subscribe(params => {
      this._api.getFacturasById(params['id']).subscribe(
        result => {
          this.facturaDefault = result[0];
          console.log(result);
        },
        err => {
          console.log(err);
          this._router.navigateByUrl('404');
        }
      );
    })
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/adminUser/myShopping/myShopping.component.ts